import dynamic from 'next/dynamic';

const ArnmAccidentsGrid = dynamic(() =>
  import('./ArnmAccidentsGrid/ArnmAccidentsGrid')
);
const AddArnmAccidentsModal = dynamic(() =>
  import('./AddArnmAccidentsModal/AddArnmAccidentsModal')
);

const ArnmAccidentsVehicleHeader = dynamic(() =>
  import('./ArnmAccidentsVehicleHeader/ArnmAccidentsVehicleHeader')
);

const ArnmAccidentsFilter = dynamic(() =>
  import('./ArnmAccidentsFilter/ArnmAccidentsFilter')
);
const AccidentForm = dynamic(() => import('./AccidentForm/AccidentForm'));
const ArnmAccidentsContent = dynamic(() =>
  import('./ArnmAccidentsContent/ArnmAccidentsContent')
);

export {
  ArnmAccidentsGrid,
  AddArnmAccidentsModal,
  ArnmAccidentsVehicleHeader,
  ArnmAccidentsFilter,
  AccidentForm,
  ArnmAccidentsContent,
};
